import "./legal.css";

export function Privacy() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <a href="/" className="back-link">&larr; Back to Home</a>

        <h1>Privacy Policy</h1>
        <p className="last-updated">Last updated: February 1, 2026</p>

        <section>
          <h2>Introduction</h2>
          <p>
            Welcome to Kris & Heejin ("we," "our," or "us"). We are committed to protecting
            your privacy and ensuring you have a positive experience on our website
            at <a href="https://krisandheejin.com">https://krisandheejin.com</a> (the "Site").
          </p>
          <p>
            This Privacy Policy explains how we collect, use, disclose, and safeguard your
            information when you visit our Site or use our services.
          </p>
        </section>

        <section>
          <h2>Information We Collect</h2>
          <h3>Information You Provide</h3>
          <p>We may collect information you voluntarily provide, including:</p>
          <ul>
            <li>Name and email address when you contact us</li>
            <li>Account information if you sign in using Google OAuth</li>
            <li>Any other information you choose to provide</li>
          </ul>

          <h3>Information Collected Automatically</h3>
          <p>When you visit our Site, we may automatically collect:</p>
          <ul>
            <li>Device information (browser type, operating system)</li>
            <li>IP address and general location</li>
            <li>Usage data (pages visited, time spent on site)</li>
          </ul>

          <h3>Google OAuth</h3>
          <p>
            If you choose to sign in using Google, we receive basic profile information
            from your Google account, which may include your name, email address, and
            profile picture. We use this information solely to authenticate your identity
            and provide you access to our services.
          </p>
        </section>

        <section>
          <h2>How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide, operate, and maintain our Site and services</li>
            <li>Authenticate your identity and manage your account</li>
            <li>Respond to your comments, questions, and requests</li>
            <li>Improve our Site and user experience</li>
            <li>Send you updates and administrative messages</li>
            <li>Protect against unauthorized access and legal liability</li>
          </ul>
        </section>

        <section>
          <h2>Data Sharing and Disclosure</h2>
          <p>
            We do not sell, trade, or rent your personal information to third parties.
            We may share your information only in the following circumstances:
          </p>
          <ul>
            <li>With your consent</li>
            <li>To comply with legal obligations</li>
            <li>To protect our rights and safety</li>
            <li>With service providers who assist in operating our Site (subject to confidentiality agreements)</li>
          </ul>
        </section>

        <section>
          <h2>Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect
            your personal information against unauthorized access, alteration, disclosure,
            or destruction. However, no method of transmission over the Internet is 100%
            secure, and we cannot guarantee absolute security.
          </p>
        </section>

        <section>
          <h2>Data Retention</h2>
          <p>
            We retain your personal information only for as long as necessary to fulfill
            the purposes for which it was collected, or as required by law. When your
            information is no longer needed, we will securely delete or anonymize it.
          </p>
        </section>

        <section>
          <h2>Your Rights</h2>
          <p>Depending on your location, you may have the right to:</p>
          <ul>
            <li>Access the personal information we hold about you</li>
            <li>Request correction of inaccurate information</li>
            <li>Request deletion of your information</li>
            <li>Object to or restrict processing of your information</li>
            <li>Request data portability</li>
            <li>Withdraw consent at any time</li>
          </ul>
          <p>
            To exercise any of these rights, please contact us at{" "}
            <a href="mailto:support@krisandheejin.com">support@krisandheejin.com</a>.
          </p>
        </section>

        <section>
          <h2>Cookies</h2>
          <p>
            Our Site may use cookies and similar tracking technologies to enhance your
            experience. You can control cookies through your browser settings. Disabling
            cookies may affect some features of the Site.
          </p>
        </section>

        <section>
          <h2>Third-Party Links</h2>
          <p>
            Our Site may contain links to third-party websites. We are not responsible
            for the privacy practices of these external sites. We encourage you to review
            their privacy policies.
          </p>
        </section>

        <section>
          <h2>Children's Privacy</h2>
          <p>
            Our Site is not intended for children under 13 years of age. We do not
            knowingly collect personal information from children under 13.
          </p>
        </section>

        <section>
          <h2>Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of
            any changes by posting the new policy on this page and updating the "Last
            updated" date.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at:
          </p>
          <p>
            <strong>Email:</strong>{" "}
            <a href="mailto:support@krisandheejin.com">support@krisandheejin.com</a>
          </p>
          <p>
            <strong>Website:</strong>{" "}
            <a href="https://krisandheejin.com">https://krisandheejin.com</a>
          </p>
        </section>
      </div>
    </div>
  );
}